import AjaxUtils from './ajaxUtils';

const fetchUserOnDemandSettings = async () => AjaxUtils.get('/api/v1/on-demand/settings');

const createUserOnDemandSettings = async payload => AjaxUtils.post('/api/v1/on-demand/settings', payload);

const updateUserOnDemandSettings = async payload => AjaxUtils.patch('/api/v1/on-demand/settings', payload);

const fetchOnDemandContacts = async payload => AjaxUtils.post('/api/v2/search/fetch-contacts-by-user-id', payload);

const updateUserOnDemandInfo = async () => AjaxUtils.get('/api/v1/on-demand/info');

export {
  createUserOnDemandSettings,
  fetchOnDemandContacts,
  fetchUserOnDemandSettings,
  updateUserOnDemandInfo,
  updateUserOnDemandSettings,
};
